import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";
import {
  VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_API_PATH,
  VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_OPERATION,
} from "./use-vehicle-valuation-vehicle-data-repair-status.query";

const VEHICLE_RESOURCE = "vehicle" as const;

export type VehicleValuationVehicleDataRepairResponse =
  paths[typeof VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationVehicleDataRepairMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationVehicleDataRepairResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationVehicleDataRepairResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/${VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_OPERATION}`,
      );

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [VEHICLE_VALUATION_RESOURCE] }),
        queryClient.invalidateQueries({ queryKey: [VEHICLE_RESOURCE] }),
      ]);
    },
  });
}
